import heroBG from "../assets/images/hero_bg.png";

const HeroSection = ({
  downloadAppRef,
}: {
  downloadAppRef: React.RefObject<HTMLElement | null>;
}) => {
  const scrollToSection = (sectionRef: React.RefObject<HTMLElement | null>) => {
    sectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="all-main-section"
      style={{
        backgroundImage: `url(${heroBG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        height: "80vh",
        overflow: "hidden",

      }}>
      <div className="all-main-section-content-wrapper">
        <div className="hero-content">
          <h2 className="all-main-title" style={{ textAlign: "center" }}>
            <span>Food</span> You Love. <span>Groceries</span> You Need.
          </h2>
          <p className="all-main-paragraph" style={{ textAlign: "center" }}>
            Your one-stop shop for tasty dishes and fresh groceries, delivered on demand.
          </p>
          <div className="store-buttons" style={{ justifyContent: "center" }}>
            <button
              className="cta-button primary"
              onClick={(e) => { e.preventDefault(); scrollToSection(downloadAppRef); }}
            >
              Register Your Business
            </button>
            <button
              className="cta-button secondary"
              onClick={(e) => { e.preventDefault(); scrollToSection(downloadAppRef); }}
            >
              Download The App
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
